import React from "react";
import { FormInputCheckbox, Spacing } from "folksam-ui";

function selectValue(value, selected, all) {
  const at = all.indexOf(value);
  const updated = selected.slice(0, at).concat(value, selected.slice(at));
  // As inserting values at predefined index positions doesn't work with empty
  // arrays, we need to reorder the updated selection to match the initial order
  return updated.sort((a, b) => all.indexOf(a) > all.indexOf(b));
}

function deselectValue(value, selected) {
  return selected.filter(v => v !== value);
}

/**
 * This is a modifed version of the core widget
 * See https://github.com/mozilla-services/react-jsonschema-form/blob/v1.2.0/src/components/widgets/CheckboxesWidget.js
 */
const CheckboxesWidget = ({
  id,
  disabled,
  options,
  value,
  autofocus,
  readonly,
  onChange
}) => {
  const { enumOptions, enumDisabled } = options;
  return (
    <div className="checkboxes" id={id}>
      {enumOptions.map((option, index) => {
        const checked = value.indexOf(option.value) !== -1;
        const itemDisabled =
          // eslint-disable-next-line
          enumDisabled && enumDisabled.indexOf(option.value) != -1;

        return (
          <Spacing key={`${id}_${index}`} y={"1"}>
            <FormInputCheckbox
              type="checkbox"
              id={`${id}_${index}`}
              name={`${id}_${index}`}
              checked={checked}
              value={option.label}
              label={option.label}
              disabled={disabled || itemDisabled || readonly}
              autoFocus={autofocus && index === 0}
              onChange={event => {
                const all = enumOptions.map(({ value }) => value);
                if (event.target.checked) {
                  onChange(selectValue(option.value, value, all));
                } else {
                  onChange(deselectValue(option.value, value));
                }
              }}
            />
          </Spacing>
        );
      })}
    </div>
  );
};

CheckboxesWidget.defaultProps = {
  autofocus: false,
  options: {
    inline: false
  }
};

export default CheckboxesWidget;
